import { PayloadAction } from 'app/shared/model/action.model';
import { EmailDomainPropertyValue, SupplierAddressPropertyValues, SupplierContactPropertyValue, SupplierDiversityPropertyValue, SupplierEhsResponsePropertyValue } from 'app/profile/models/supplier.model';
import { SupplierWarehouse } from 'app/profile/models/profile.model';
import { any } from 'underscore';
import { SupplierCommunicationValidation } from 'app/profile/models/generic.model';
import { SupplierTaskDetail } from 'app/profile/models/suppliertasks.model';

export const GET_SUPPLIER_PROFILE_CURRENT_USER = 'GET_MD_SUPPLIER_PROFILE_CURRENT_USER';
export class GetSupplierProfileCurrentUser implements PayloadAction {
  readonly type = GET_SUPPLIER_PROFILE_CURRENT_USER;
  constructor(public payload?, public forceReload: boolean = false) { }
}

export const GET_SUPPLIER_PROFILE_CURRENT_USER_SUCCESS = 'GET_MD_SUPPLIER_PROFILE_CURRENT_USER_SUCCESS';
export class GetSupplierProfileCurrentUserSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_PROFILE_CURRENT_USER_SUCCESS;
  constructor(public payload) { }
}

export const GET_SUPPLIER_PROFILE_NAVIGATION_ITEMS = 'GET_SUPPLIER_PROFILE_NAVIGATION_ITEMS';
export class GetSupplierProfileNavigationItems implements PayloadAction {
  readonly type = GET_SUPPLIER_PROFILE_NAVIGATION_ITEMS;
  constructor(public payload?, public forceReload: boolean = false) { }
}

export const GET_SUPPLIER_PROFILE_NAVIGATION_ITEMS_SUCCESS = 'GET_SUPPLIER_PROFILE_NAVIGATION_ITEMS_SUCCESS';
export class GetSupplierProfileNavigationItemsSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_PROFILE_NAVIGATION_ITEMS_SUCCESS;
  constructor(public payload?, public forceReload: boolean = false) { }
}

export const GET_SUPPLIER_ADDRESS_LIST_BY_CODE = 'GET_SUPPLIER_ADDRESS_LIST_BY_CODE';
export class GetSupplierAddressListByCode implements PayloadAction {
  readonly type = GET_SUPPLIER_ADDRESS_LIST_BY_CODE;
  constructor(public payload, public forceReload: boolean = false) {
  }
}

export const GET_SUPPLIER_ADDRESS_LIST_BY_CODE_SUCCESS = 'GET_SUPPLIER_ADDRESS_LIST_BY_CODE_SUCCESS';
export class GetSupplierAddressListByCodeSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_ADDRESS_LIST_BY_CODE_SUCCESS;
  constructor(public payload) { }
}

export const CLEAR_SUPPLIER_DETAILS_BY_CODE = 'CLEAR_SUPPLIER_DETAILS_BY_CODE';
export class ClearSupplierDetailsByCode implements PayloadAction {
  readonly type = CLEAR_SUPPLIER_DETAILS_BY_CODE;
  constructor(public payload?) { }
}

export const GET_SUPPLIER_DOCUMENTS_LIST_BY_CODE = 'GET_SUPPLIER_DOCUMENTS_LIST_BY_CODE';
export class GetSupplierDocumentsListByCode implements PayloadAction {
  readonly type = GET_SUPPLIER_DOCUMENTS_LIST_BY_CODE;
  constructor(public payload, public forceReload: boolean = false) {
  }
}

export const GET_SUPPLIER_DOCUMENTS_LIST_BY_CODE_SUCCESS = 'GET_SUPPLIER_DOCUMENTS_LIST_BY_CODE_SUCCESS';
export class GetSupplierDocumentsListByCodeSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_DOCUMENTS_LIST_BY_CODE_SUCCESS;
  constructor(public payload) {
  }
}

export const GET_SUPPLIER_MFG_ADDRESS_LIST_BY_CODE = 'GET_SUPPLIER_MFG_ADDRESS_LIST_BY_CODE';
export class GetSupplierMfgAddressListByCode implements PayloadAction {
  readonly type = GET_SUPPLIER_MFG_ADDRESS_LIST_BY_CODE;
  constructor(public payload, public forceReload: boolean = false) {
  }
}

export const GET_SUPPLIER_MFG_ADDRESS_LIST_BY_CODE_SUCCESS = 'GET_SUPPLIER_MFG_ADDRESS_LIST_BY_CODE_SUCCESS';
export class GetSupplierMfgAddressListByCodeSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_MFG_ADDRESS_LIST_BY_CODE_SUCCESS;
  constructor(public payload) { }
}

export const ADD_SUPPLIER_ADDRESS = 'ADD_SUPPLIER_ADDRESS';
export const EDIT_SUPPLIER_ADDRESS = 'EDIT_SUPPLIER_ADDRESS';
export const DELETE_SUPPLIER_ADDRESS = 'DELETE_SUPPLIER_ADDRESS';
export class AddSupplierAddress implements PayloadAction {
  readonly type = ADD_SUPPLIER_ADDRESS;
  constructor(public payload: SupplierAddressPropertyValues) { }
}
export class EditSupplierAddress implements PayloadAction {
  readonly type = EDIT_SUPPLIER_ADDRESS;
  constructor(public payload) { }
}
export class DeleteSupplierAddress implements PayloadAction {
  readonly type = DELETE_SUPPLIER_ADDRESS;
  constructor(public payload: number) { }
}

export const DELETE_SUPPLIER_BANK = 'DELETE_SUPPLIER_BANK';
export class DeleteSupplierBank implements PayloadAction {
  readonly type = DELETE_SUPPLIER_BANK;
  constructor(public payload: number) { }
}

export const DELETE_SUPPLIER_TAX = 'DELETE_SUPPLIER_TAX';
export class DeleteSupplierTax implements PayloadAction {
  readonly type = DELETE_SUPPLIER_TAX;
  constructor(public payload: number) { }
}

export const ADD_SUPPLIER_ADDRESS_DOCUMENT = 'ADD_SUPPLIER_ADDRESS_DOCUMENT';
export class AddSupplierAddressDocument implements PayloadAction {
  readonly type = ADD_SUPPLIER_ADDRESS_DOCUMENT;
  constructor(public payload) { }
}

export const GET_TAB_PERMISSIONS = 'GET_TAB_PERMISSIONS';
export const GET_TAB_PERMISSIONS_SUCCESS = 'GET_TAB_PERMISSIONS_SUCCESS';
export class GetTabPermissions implements PayloadAction {
  readonly type = GET_TAB_PERMISSIONS;
  constructor(public payload?, public forceReload: boolean = false) { }
}
export class GetTabPermissionsSuccess implements PayloadAction {
  readonly type = GET_TAB_PERMISSIONS_SUCCESS;
  constructor(public payload) { }
}

export const GET_SUPPLIER_PROFILE = 'GET_SUPPLIER_PROFILE';
export const GET_SUPPLIER_PROFILE_SUCCESS = 'GET_SUPPLIER_PROFILE_SUCCESS';
export class GetSupplierProfile implements PayloadAction {
  readonly type = GET_SUPPLIER_PROFILE;
  constructor(public payload?, public forceReload: boolean = false) { }
}
export class GetSupplierProfileSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_PROFILE_SUCCESS;
  constructor(public payload) { }
}

export const GET_FIELD_CONFIG = 'GET_FIELD_CONFIG';
export const GET_FIELD_CONFIG_SUCCESS = 'GET_FIELD_CONFIG_SUCCESS';
export class GetFieldConfiguration implements PayloadAction {
  readonly type = GET_FIELD_CONFIG;
  constructor(public payload) { }
}
export class GetFieldConfigurationSuccess implements PayloadAction {
  readonly type = GET_FIELD_CONFIG_SUCCESS;
  constructor(public payload) { }
}

export const GET_SUPPLIER_CONTACT_LIST_BY_CODE = 'GET_SUPPLIER_CONTACT_LIST_BY_CODE';
export class GetSupplierContactListByCode implements PayloadAction {
  readonly type = GET_SUPPLIER_CONTACT_LIST_BY_CODE;
  constructor(public payload, public forceReload: boolean = false) {
  }
}

export const GET_SUPPLIER_CONTACT_LIST_BY_CODE_SUCCESS = 'GET_SUPPLIER_CONTACT_LIST_BY_CODE_SUCCESS';
export class GetSupplierContactListByCodeSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_CONTACT_LIST_BY_CODE_SUCCESS;
  constructor(public payload) { }
}

export const GET_PREVENTATIVE_IN_PROGRESS = 'GET_PREVENTATIVE_IN_PROGRESS';
export class GetPreventativeInProgress implements PayloadAction {
  readonly type = GET_PREVENTATIVE_IN_PROGRESS;
  constructor(public payload, public forceReload: boolean = false) {
  }
}

export const GET_PREVENTATIVE_IN_PROGRESS_SUCCESS = 'GET_PREVENTATIVE_IN_PROGRESS_SUCCESS';
export class GetPreventativeInProgressSuccess implements PayloadAction {
  readonly type = GET_PREVENTATIVE_IN_PROGRESS_SUCCESS;
  constructor(public payload) { }
}

export const GET_SUPPLIER_PENDING_TASKS_CODE = 'GET_SUPPLIER_PENDING_TASKS_CODE';
export class GetSupplierPendingTasksByCode implements PayloadAction {
  readonly type = GET_SUPPLIER_PENDING_TASKS_CODE;
  constructor(public payload, public forceReload: boolean = false) {
  }
}

export const GET_SUPPLIER_PENDING_TASKS_CODE_SUCCESS = 'GET_SUPPLIER_PENDING_TASKS_CODE_SUCCESS';
export class GetSupplierPendingTasksByCodeSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_PENDING_TASKS_CODE_SUCCESS;
  constructor(public payload: SupplierTaskDetail[]) { }
}

export const GET_SUPPLIER_ENTITY_LIST_BY_CODE = 'GET_SUPPLIER_ENTITY_LIST_BY_CODE';
export class GetSupplierEntityListByCode implements PayloadAction {
  readonly type = GET_SUPPLIER_ENTITY_LIST_BY_CODE;
  constructor(public payload, public forceReload: boolean = false) {
  }
}

export const GET_SUPPLIER_ENTITY_LIST_BY_CODE_SUCCESS = 'GET_SUPPLIER_ENTITY_LIST_BY_CODE_SUCCESS';
export class GetSupplierEntityListByCodeSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_ENTITY_LIST_BY_CODE_SUCCESS;
  constructor(public payload) { }
}

export const ADD_SUPPLIER_CONTACT = 'ADD_SUPPLIER_CONTACT';
export const EDIT_SUPPLIER_CONTACT = 'EDIT_SUPPLIER_CONTACT';
export const DELETE_SUPPLIER_CONTACT = 'DELETE_SUPPLIER_CONTACT';
export class AddSupplierContact implements PayloadAction {
  readonly type = ADD_SUPPLIER_CONTACT;
  constructor(public payload: SupplierContactPropertyValue) { }
}
export class EditSupplierContact implements PayloadAction {
  readonly type = EDIT_SUPPLIER_CONTACT;
  constructor(public payload) { }
}
export class DeleteSupplierContact implements PayloadAction {
  readonly type = DELETE_SUPPLIER_CONTACT;
  constructor(public payload: number) { }
}

export const ADD_WAREHOUSE_SUPPLIER_ADDRESS = 'ADD_WAREHOUSE_SUPPLIER_ADDRESS';
export const EDIT_WAREHOUSE_SUPPLIER_ADDRESS = 'EDIT_WAREHOUSE_SUPPLIER_ADDRESS';
export const DELETE_WAREHOUSE_SUPPLIER_ADDRESS = 'DELETE_WAREHOUSE_SUPPLIER_ADDRESS';
export class AddWarehouseSupplierAddress implements PayloadAction {
  readonly type = ADD_WAREHOUSE_SUPPLIER_ADDRESS;
  constructor(public payload: SupplierAddressPropertyValues) { }
}
export class EditWarehouseSupplierAddress implements PayloadAction {
  readonly type = EDIT_WAREHOUSE_SUPPLIER_ADDRESS;
  constructor(public payload) { }
}
export class DeleteWarehouseSupplierAddress implements PayloadAction {
  readonly type = DELETE_WAREHOUSE_SUPPLIER_ADDRESS;
  constructor(public payload: number) { }
}

export const GET_SUPPLIER_WAREHOUSE_ADDRESS_LIST_BY_CODE = 'GET_SUPPLIER_WAREHOUSE_ADDRESS_LIST_BY_CODE';
export class GetSupplierWarehouseAddressListByCode implements PayloadAction {
  readonly type = GET_SUPPLIER_WAREHOUSE_ADDRESS_LIST_BY_CODE;
  constructor(public payload, public forceReload: boolean = false) {
  }
}

export const GET_SUPPLIER_WAREHOUSE_ADDRESS_LIST_BY_CODE_SUCCESS = 'GET_SUPPLIER_WAREHOUSE_ADDRESS_LIST_BY_CODE_SUCCESS';
export class GetSupplierWarehouseAddressListByCodeSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_WAREHOUSE_ADDRESS_LIST_BY_CODE_SUCCESS;
  constructor(public payload) { }
}

export const GET_SUPPLIER_PICKUP_WAREHOUSE_ADDRESS_LIST_BY_CODE = 'GET_SUPPLIER_PICKUP_WAREHOUSE_ADDRESS_LIST_BY_CODE';
export class GetSupplierPickupWarehouseAddressListByCode implements PayloadAction {
  readonly type = GET_SUPPLIER_PICKUP_WAREHOUSE_ADDRESS_LIST_BY_CODE;
  constructor(public payload, public forceReload: boolean = false) {
  }
}

export const GET_SUPPLIER_PICKUP_WAREHOUSE_ADDRESS_LIST_BY_CODE_SUCCESS = 'GET_SUPPLIER_PICKUP_WAREHOUSE_ADDRESS_LIST_BY_CODE_SUCCESS';
export class GetSupplierPickupWarehouseAddressListByCodeSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_PICKUP_WAREHOUSE_ADDRESS_LIST_BY_CODE_SUCCESS;
  constructor(public payload) { }
}

export const GET_SUPPLIER_EXTERNAL_PARTNER_LIST = 'GET_SUPPLIER_EXTERNAL_PARTNER_LIST';
export class GetSupplierExernalPartnerList implements PayloadAction {
  readonly type = GET_SUPPLIER_EXTERNAL_PARTNER_LIST;
  constructor(public payload, public forceReload: boolean = false) {
  }
}

export const GET_SUPPLIER_EXTERNAL_PARTNER_LIST_SUCCESS = 'GET_SUPPLIER_EXTERNAL_PARTNER_LIST_SUCCESS';
export class GetSupplierExernalPartnerListSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_EXTERNAL_PARTNER_LIST_SUCCESS;
  constructor(public payload: SupplierAddressPropertyValues[]) {
  }
}

export const GET_VALIDATION_TASK_BY_CODE = 'GET_VALIDATION_TASK_BY_CODE';
export class GetValidationTaskByCode implements PayloadAction {
  readonly type = GET_VALIDATION_TASK_BY_CODE;
  constructor(public payload, public forceReload: boolean = false) {
  }
}

export const GET_VALIDATION_TASK_BY_CODE_SUCCESS = 'GET_VALIDATION_TASK_BY_CODE_SUCCESS';
export class GetValidationTaskByCodeSuccess implements PayloadAction {
  readonly type = GET_VALIDATION_TASK_BY_CODE_SUCCESS;
  constructor(public payload) {
  }
}

export const GET_CONTRACTS_BY_CODE = 'GET_CONTRACTS_BY_CODE';
export class GetContractsByCode implements PayloadAction {
  readonly type = GET_CONTRACTS_BY_CODE;
  constructor(public payload, public forceReload: boolean = false) {
  }
}

export const GET_CONTRACTS_BY_CODE_SUCCESS = 'GET_CONTRACTS_BY_CODE_SUCCESS';
export class GetContractsByCodeSuccess implements PayloadAction {
  readonly type = GET_CONTRACTS_BY_CODE_SUCCESS;
  constructor(public payload) {
  }
}

export const GET_SUPPLIER_LOCATIONS_BY_CODE = 'GET_SUPPLIER_LOCATIONS_BY_CODE';
export class GetSupplierLocationsByCode implements PayloadAction {
  readonly type = GET_SUPPLIER_LOCATIONS_BY_CODE;
  constructor(public payload, public forceReload: boolean = false) {
  }
}

export const GET_SUPPLIER_LOCATIONS_BY_CODE_SUCCESS = 'GET_SUPPLIER_LOCATIONS_BY_CODE_SUCCESS';
export class GetSupplierLocationsByCodeSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_LOCATIONS_BY_CODE_SUCCESS;
  constructor(public payload) { }
}

export const CLEAR_SUPPLIER_BANKS = 'CLEAR_SUPPLIER_BANKS';
export class ClearSupplierBanks implements PayloadAction {
  readonly type = CLEAR_SUPPLIER_BANKS;
  constructor(public payload?) { }
}

export const CLEAR_SUPPLIER_TAXES = 'CLEAR_SUPPLIER_TAXES';
export class ClearSupplierTaxes implements PayloadAction {
  readonly type = CLEAR_SUPPLIER_TAXES;
  constructor(public payload?) { }
}

export const GET_SUPPLIER_BANK_LIST_BY_CODE = 'GET_SUPPLIER_BANK_LIST_BY_CODE';
export class GetSupplierBankListByCode implements PayloadAction {
  readonly type = GET_SUPPLIER_BANK_LIST_BY_CODE;
  constructor(public payload, public forceReload: boolean = false) {
  }
}

export const GET_SUPPLIER_BANK_LIST_BY_CODE_SUCCESS = 'GET_SUPPLIER_BANK_LIST_BY_CODE_SUCCESS';
export class GetSupplierBankListByCodeSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_BANK_LIST_BY_CODE_SUCCESS;
  constructor(public payload) {
  }
}

export const GET_SUPPLIER_TAX_LIST_BY_CODE = 'GET_SUPPLIER_TAX_LIST_BY_CODE';
export class GetSupplierTaxListByCode implements PayloadAction {
  readonly type = GET_SUPPLIER_TAX_LIST_BY_CODE;
  constructor(public payload, public forceReload: boolean = false) {
  }
}

export const GET_SUPPLIER_TAX_LIST_BY_CODE_SUCCESS = 'GET_SUPPLIER_TAX_LIST_BY_CODE_SUCCESS';
export class GetSupplierTaxListByCodeSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_TAX_LIST_BY_CODE_SUCCESS;
  constructor(public payload) {
  }
}


export const GET_SUPPLIER_DIVERSITY_BY_CODE = 'GET_SUPPLIER_DIVERSITY_BY_CODE';
export const GET_SUPPLIER_DIVERSITY_BY_CODE_SUCCESS = 'GET_SUPPLIER_DIVERSITY_BY_CODE_SUCCESS';
export class GetSupplierDiversityByCode implements PayloadAction {
  readonly type = GET_SUPPLIER_DIVERSITY_BY_CODE;
  constructor(public payload, public forceReload: boolean = false) { }
}


export class GetSupplierDiversityByCodeSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_DIVERSITY_BY_CODE_SUCCESS;
  constructor(public payload: SupplierDiversityPropertyValue) { }
}

export const GET_EMAIL_DOMAINS = 'GET_EMAIL_DOMAINS';
export const GET_EMAIL_DOMAINS_SUCCESS = 'GET_EMAIL_DOMAINS_SUCCESS';
export class GetEmailDomains implements PayloadAction {
  readonly type = GET_EMAIL_DOMAINS;
  constructor(public payload, public forceReload: boolean = false) { }
}
export class GetEmailDomainsSuccess implements PayloadAction {
  readonly type = GET_EMAIL_DOMAINS_SUCCESS;
  constructor(public payload) { }
}

export const LINK_DELINK_SUPPLIER_ADDRESS_CONTACTS = 'LINK_DELINK_SUPPLIER_ADDRESS_CONTACTS';
export const LINK_DELINK_SUPPLIER_ADDRESS_CONTACTS_SUCCESS = 'LINK_DELINK_SUPPLIER_ADDRESS_CONTACTS_SUCCESS';
export class LinkDelinkSupplierAddressContacts implements PayloadAction {
  readonly type = LINK_DELINK_SUPPLIER_ADDRESS_CONTACTS;
  constructor(public payload) { }
}
export class LinkDelinkSupplierAddressContactsSuccess implements PayloadAction {
  readonly type = LINK_DELINK_SUPPLIER_ADDRESS_CONTACTS_SUCCESS;
  constructor(public payload) { }
}


export const GET_SUPPLIER_EHS_RESPONSE_BY_CODE = 'GET_SUPPLIER_EHS_RESPONSE_BY_CODE';
export const GET_SUPPLIER_EHS_RESPONSE_BY_CODE_SUCCESS = 'GET_SUPPLIER_EHS_RESPONSE_BY_CODE_SUCCESS';
export class GetSupplierEhsResponseByCode implements PayloadAction {
  readonly type = GET_SUPPLIER_EHS_RESPONSE_BY_CODE;
  constructor(public payload, public forceReload: boolean = false) { }
}
export class GetSupplierEhsResponseByCodeSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_EHS_RESPONSE_BY_CODE_SUCCESS;
  constructor(public payload: SupplierEhsResponsePropertyValue[]) { }
}

export const GET_SUPPLIER_CHANNEL_LIST_BY_CODE = 'GET_SUPPLIER_CHANNEL_LIST_BY_CODE';
export class GetSupplierChannelListByCode implements PayloadAction {
  readonly type = GET_SUPPLIER_CHANNEL_LIST_BY_CODE;
  constructor(public payload, public forceReload: boolean = false) {
  }
}

export const GET_SUPPLIER_CHANNEL_LIST_BY_CODE_SUCCESS = 'GET_SUPPLIER_CHANNEL_LIST_BY_CODE_SUCCESS';
export class GetSupplierChannelListByCodeSuccess implements PayloadAction {
  readonly type = GET_SUPPLIER_CHANNEL_LIST_BY_CODE_SUCCESS;
  constructor(public payload) { }
}

export const GET_SUPPLIER_OTP_REQUEST_BY_USER = 'GET_SUPPLIER_OTP_REQUEST_BY_USER';
export const GET_SUPPLIER_OTP_REQUEST_BY_USER_SUCCESS = 'GET_SUPPLIER_OTP_REQUEST_BY_USER_SUCCESS';
export class GetSupplierOtpRequestByUser implements PayloadAction {
  readonly type = GET_SUPPLIER_OTP_REQUEST_BY_USER;
  constructor(public supplierCode, public forceReload: boolean = false) { }
}
export class GetSupplierOtpRequestByUserSucess implements PayloadAction {
  readonly type = GET_SUPPLIER_OTP_REQUEST_BY_USER_SUCCESS;
  constructor(public payload: SupplierCommunicationValidation) { }
}

export type SupplierStateActions = GetSupplierProfileCurrentUser | GetSupplierProfileCurrentUserSuccess
  | GetSupplierAddressListByCode | GetSupplierAddressListByCodeSuccess
  | AddSupplierAddress | EditSupplierAddress | DeleteSupplierAddress | AddSupplierAddressDocument
  | GetTabPermissions | GetTabPermissionsSuccess
  | GetSupplierProfile | GetSupplierProfileSuccess
  | GetSupplierContactListByCode | GetSupplierContactListByCodeSuccess
  | GetSupplierEntityListByCode | GetSupplierEntityListByCodeSuccess
  | AddSupplierContact | EditSupplierContact | DeleteSupplierContact
  | GetFieldConfiguration | GetFieldConfigurationSuccess
  | ClearSupplierDetailsByCode | GetSupplierDocumentsListByCode | GetSupplierDocumentsListByCodeSuccess
  | AddWarehouseSupplierAddress | EditWarehouseSupplierAddress | DeleteWarehouseSupplierAddress
  | GetSupplierWarehouseAddressListByCode | GetSupplierWarehouseAddressListByCodeSuccess
  | GetSupplierPickupWarehouseAddressListByCode | GetSupplierPickupWarehouseAddressListByCodeSuccess
  | GetSupplierExernalPartnerList | GetSupplierExernalPartnerListSuccess
  | GetValidationTaskByCode | GetValidationTaskByCodeSuccess
  | GetContractsByCode | GetContractsByCodeSuccess
  | GetSupplierLocationsByCode | GetSupplierLocationsByCodeSuccess
  | GetSupplierBankListByCode | GetSupplierBankListByCodeSuccess | ClearSupplierBanks
  | DeleteSupplierBank | ClearSupplierTaxes | DeleteSupplierTax
  | GetEmailDomains | GetEmailDomainsSuccess | GetSupplierProfileNavigationItems | GetSupplierProfileNavigationItemsSuccess
  | GetSupplierMfgAddressListByCodeSuccess | GetSupplierTaxListByCode | GetSupplierTaxListByCodeSuccess
  | GetSupplierDiversityByCode | GetSupplierDiversityByCodeSuccess | GetSupplierEhsResponseByCode
  | GetSupplierEhsResponseByCodeSuccess | GetSupplierChannelListByCode | GetSupplierChannelListByCodeSuccess | GetSupplierPendingTasksByCode | GetSupplierPendingTasksByCodeSuccess
  | GetSupplierOtpRequestByUser | GetSupplierOtpRequestByUserSucess | GetPreventativeInProgress | GetPreventativeInProgressSuccess;
